export default __webpack_public_path__ + "static/media/Valentine Kahambu.d5b85522.JPG";